export default "__VITE_ASSET__C59BhRV8__"